import React, { useRef } from 'react';
import Slider, { Settings } from 'react-slick';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { AchievementBadgeImage } from '../../components/AchievementBadge';
import { trackBadgeSwipe } from '../../lib/analytics';
import styles from './styles.module.scss';

interface WelcomeProps {
  isLogin?: boolean;
  className?: string;
  autoPlay?: boolean;
  isChildTimeline?: boolean;
}

// TODO: swap this out for https://swiperjs.com/react

const smallSize = '130px';
const mediumSize = '130px';
const largeSize = '180px';

const defaultArray = [smallSize, largeSize];
const childTimeLineArray = [smallSize, mediumSize, largeSize];

function WelcomeSlider({
  isLogin = false,
  className = '',
  autoPlay = false,
  isChildTimeline = false,
}: WelcomeProps): React.ReactElement {
  const sliderRef = useRef<Slider>(null);
  const sliderSettings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    dotsClass: isLogin ? styles.dotClassWhite : styles.dotClass,
    className,
    onSwipe(swipeDirection: 'left' | 'right') {
      trackBadgeSwipe(swipeDirection);
    },
  };

  if (autoPlay) {
    sliderSettings.autoplay = true;
    sliderSettings.autoplaySpeed = 3000;
    sliderSettings.infinite = true;
  }

  return (
    <Slider {...sliderSettings} ref={sliderRef}>
      <AchievementBadgeImage
        image="sun"
        size={isChildTimeline ? childTimeLineArray : defaultArray}
      />
      <AchievementBadgeImage
        image="start_early"
        size={isChildTimeline ? childTimeLineArray : defaultArray}
      />
      <AchievementBadgeImage
        image="plant"
        size={isChildTimeline ? childTimeLineArray : defaultArray}
      />
    </Slider>
  );
}

WelcomeSlider.displayName = 'WelcomeSlider';

export default WelcomeSlider;
